export default "__VITE_ASSET__nqfnGcuf__"